import type { CourseDetailSummaryInstructorBasicInfo } from './courseDetailSummaryInstructorBasicInfo';
import type { CourseDetailSummaryInstructorSocial } from './courseDetailSummaryInstructorSocial';

/**
 * 강사 정보
 */
export type CourseDetailSummaryInstructor = {
  /** 사용자 기본 정보 */
  basicInfo: CourseDetailSummaryInstructorBasicInfo;
  /** 소셜 관계 정보 */
  social?: CourseDetailSummaryInstructorSocial;
};
